import { render, staticRenderFns } from "./DictionaryAcceptanceWordsEdit.vue?vue&type=template&id=03c2e901&scoped=true&"
import script from "./DictionaryAcceptanceWordsEdit.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptanceWordsEdit.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryAcceptanceWordsEdit.vue?vue&type=style&index=0&id=03c2e901&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2e901",
  null
  
)

export default component.exports